import React from "react";
import classNames from "classnames";
export const Icon = (props) => {
    return (React.createElement("svg", { "aria-hidden": true, className: classNames("icon", props.c[3]), width: props.c[1], height: props.c[2] },
        React.createElement("use", { xlinkHref: "#" + props.c[0] })));
};
